<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Roman Britain’s Pirate King</h1>
<p class="titlea">Carausius, Constantius Chlorus and the Fourth Roman Invasion of Britain</p>
<p class="author">Simon Elliott</p>
<div class="image_containerf">
<img alt="images" src="images/f0iii-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?b37bc094